import { Box, Grid, Typography } from "@mui/material";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import type { ReactNode } from "react";

type Props = { title: string; children: ReactNode };

export const Widget = ({ title, children }: Props) => (
  <Grid size={{ xs: 6, sm: 6, md: 6, lg: 3 }}>
    <PrimaryPaper
      sx={{
        width: "100%",
        margin: 0,
        height: "100%",
        minWidth: ["150px", "200px"],
      }}
    >
      <Box display="flex" flexDirection="column">
        <Typography noWrap>{title}</Typography>
        <Typography variant="h6">{children}</Typography>
      </Box>
    </PrimaryPaper>
  </Grid>
);
